'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safeParseInt = require('./safeParseInt');

var _safeParseInt2 = _interopRequireDefault(_safeParseInt);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _injectNode = require('./injectNode');

var _injectNode2 = _interopRequireDefault(_injectNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a function that updates datasource.
 * updateNode should return a new node, or nutate the node passed.
 * The new node, or the mutated node is then inserted into the dataSource.
 *
 * getDataSourceUpdater :: config -> (nodeConfig -> node) -> newDataSource
 */
var getDataSourceUpdater = function getDataSourceUpdater(_ref) {
  var data = _ref.data,
      nodeProps = _ref.nodeProps,
      extraProps = _ref.extraProps;
  return function (updateNode) {
    var indexPath = nodeProps.indexPath.split('/').map(_safeParseInt2.default);
    var node = (0, _objectAssign2.default)({}, nodeProps.node);

    // default to node (potentialy mutated) if updateNode returns null|undefined
    var newNode = updateNode((0, _objectAssign2.default)({ node: node, nodeProps: nodeProps }, extraProps)) || node;
    var newDataSource = (0, _injectNode2.default)(newNode, indexPath, data);

    return newDataSource;
  };
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

exports.default = getDataSourceUpdater;